import { ApolloLink } from 'apollo-link';
import { getMainDefinition } from 'apollo-utilities';

function coercePrimitive(val, kind) {
  let newVal;

  switch (kind) {
    case 'String':
      newVal = String(val);
      break;
    case 'Boolean':
      newVal = (String(val) === 'true');
      break;
    case 'Int':
      newVal = parseInt(val, 10);
      break;
    case 'Float':
      newVal = parseFloat(val);
      break;
    default:
      newVal = val;
  }

  return newVal;
}

// cms-api does not validate the input type, however GraphQL 14
// started validating input primitives. This normally would
// be caught via TS, but these values are not known until
// runtimes and cms-api provides no contracts for these values.
export const apolloInputCoercionLink = new ApolloLink((operation, forward) => {
  const coercedVals = {};
  const q = getMainDefinition(operation.query);
  q.variableDefinitions.forEach((def) => {
    const name = def.variable.name.value;
    const val = operation.variables[name];
    if (!val) { return; }

    // coerce just top level primitive values
    // def.type.kind is ListType for arrays, but
    // have more complicated parsing rules that
    // we hopefully do not need
    if (def.type.kind === 'NamedType') {
      const kind = def.type.name.value;
      coercedVals[name] = coercePrimitive(val, kind);
    }
  });

  operation.variables = {
    ...operation.variables,
    ...coercedVals,
  };

  return forward(operation);
});
